<template>
  <div class="drop">
    <LKRoadmapsFeedTreeAteDropToggle
      :node="node"
      @click.native="onLoadChildren"
    />

    <LKToggleContainer
      v-if="node.children.length"
      :active="node.isActive"
      :class="{ 'mod--roadmap': node.level === 3 }"
      class="drop__list"
    >
      <TreeChildren
        :node="node"
        :load-children="loadChildren"
        v-on="$listeners || {}"
      />
    </LKToggleContainer>
  </div>
</template>

<script>
import { loadChildrenMixin } from '../mixins'
import LKToggleContainer from '@/components/lk/LKToggleContainer.vue'
import TreeChildren from '../LKRoadmapsFeedTreeChildren.vue'
import LKRoadmapsFeedTreeAteDropToggle from './LKRoadmapsFeedTreeAteDropToggle.vue'


export default {
  name: 'LKRoadmapsFeedTreeDrop',
  components: {
    LKToggleContainer,
    LKRoadmapsFeedTreeAteDropToggle,
    TreeChildren,
  },
  mixins: [
    loadChildrenMixin,
  ],
}
</script>
